import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { authAPI } from "../services/AuthAPI";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, CircularProgress } from '@mui/material';
import Button from "./../components/CustomButtons/Button";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import Swal from "sweetalert2";
import LogoImage from "../assets/images/login-bg.png"
import './login.css'

const ForegetPassword = () => {
    const useStyles = makeStyles(styles);
    const navigate = useNavigate();
    const { user: { isLogin } } = useSelector(state => state)
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState(false)
    const [cardAnimaton, setCardAnimation] = useState("cardHidden");

    useEffect(() => {
        let cardAnimatonTO = setTimeout(() => {
            setCardAnimation("");
        }, 700);
        if (isLogin) {
            navigate('/')
        }
        return () => {
            clearTimeout(cardAnimatonTO)
            setEmail("")
        }
    }, [isLogin])

    const ForgetFunction = (e) => {
        try {
            e.preventDefault()
            let checkformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (email == "") throw { message: "Email ห้ามว่าง" }
            let checkemail = checkformat.test(email)
            if (!checkemail) throw { message: "Email format ไม่ถูกต้อง" }
            setLoading(true)
            authAPI.ForgetPassword({ email })
                .then((res) => {
                    setLoading(false)
                    if (res.status == 200) {
                        Swal.fire({
                            icon: 'success',
                            confirmButtonColor: "#6ab23a",
                            html: `<span class="colorWhite">ส่งข้อมูลเปลี่ยนรหัสผ่านไปยัง Email ${email} ลิงค์หมดอายุภายใน 10 นาที</span>`,
                            width: '28rem',
                            timer: 3000
                        }).then(() => {
                            navigate("/login")
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${res.message}</span>`,
                            width: '28rem',
                            timer: 3000
                        });
                    }
                })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                width: '28rem',
                timer: 3000
            });
        }
    }

    const classes = useStyles();

    return (
        !isLogin && <div onSubmit={ForgetFunction}>
            <div 
                className={`${classes.pageHeader} pageHeader`}
                style={{
                    // backgroundSize: "cover",
                    // backgroundPosition: "top center",
                    display: "grid",
                    gridTemplateColumns: "60% 40%",
                    gridTemplateRows: "100%",
                    padding: "0%",
                    margin: "0%",
                    width: '100vw',
                    height: '100vh',
                }}
            >
                <div className={`${classes.colleft} col-left`}>
                    <img className="wave" src={LogoImage} alt="" />
                    <h5 style={{ color: '#212529', fontSize: '18px', opacity: '75%' }}>Human Resources (HR)</h5>
                    <h3 style={{ color: '#212529', fontSize: '25px', fontWeight: 600 }}>HR Com7 Documentary</h3>
                </div>
                
                <div className={`${classes.container} col-right`}>
                    <GridContainer justifyContent="center">
                        <GridItem >
                            <Card className={classes[cardAnimaton]} style={{ borderRadius: '4px', boxShadow: 'none' }}>
                                <form className={classes.form}>
                                    <CardHeader color="primary" className={`${classes.cardHeader} enter-cardHeader`}>
                                        <h3 style={{ color: '#212529', fontSize: '30px', textAlign: 'center', fontWeight: 600 }}>ค้นหาบัญชีของคุณ</h3>
                                    </CardHeader>
                                    <p className={classes.divider} style={{ marginTop: '2%'}}>โปรดป้อนอีเมลของคุณ เพื่อค้นหาบัญชีของคุณ</p>
                                    <CardBody style={{ marginTop: '6%', marginBottom: '6%'}}>
                                        <TextField style={{ width: '100%' }} value={email} onChange={(e) => setEmail(e.target.value)} label="อีเมล" variant="standard" className={classes.UnderLine} />
                                    </CardBody>
                                    <CardFooter className={classes.cardFooter} style={{ flexDirection: 'row-reverse', marginLeft: '3%', marginRight: '3%'}}>
                                        {!loading ? <Button className={classes.cardButton} simple type="submit" color={`${email == "" ? "danger" : "primary"}`} style={{
                                            width: '85px',
                                            height: '32px',
                                            fontWeight: 600,
                                            borderRadius: '24px',
                                            color: 'white',
                                            backgroundColor: email == "" ? "lightgray" : '#6ab23a'
                                        }} size="lg"
                                            disabled={email == "" ? true : false}
                                            onClick={ForgetFunction}>
                                            ค้นหา
                                        </Button> : <Button className={classes.cardButton} simple type="submit" color={"primary"} style={{
                                            borderRadius: '4px',
                                            color: 'white',
                                            backgroundColor: "lightgray"
                                        }} size="lg"
                                            disabled={true}
                                        >
                                            <CircularProgress size={30} style={{ color: '#6ab23a' }} />
                                        </Button>}
                                        <span onClick={() => navigate("/login")} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#6ab23a' }}>กลับ</span>
                                    </CardFooter>
                                </form>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        </div>
    )
}
export default ForegetPassword